import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=1b968762&scoped=true&"
import script from "./AppBar.vue?vue&type=script&lang=js&"
export * from "./AppBar.vue?vue&type=script&lang=js&"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=1b968762&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b968762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b968762')) {
      api.createRecord('1b968762', component.options)
    } else {
      api.reload('1b968762', component.options)
    }
    module.hot.accept("./AppBar.vue?vue&type=template&id=1b968762&scoped=true&", function () {
      api.rerender('1b968762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppBar.vue"
export default component.exports